import { getCurrentHalfYear, getCurrentYear } from "../../../../utility/calendar";

export const importsState = {
  importsList: null,
  basicFilter:{
    semestarDate: `${getCurrentYear()} ${getCurrentHalfYear() == 0 ? "(1/2)" : "(2/2)"}`
  }
}